export const types = {
  CLOSE: 'common/drawers/downloadCuiAuditCsvDrawer/CLOSE',
  OPEN: 'common/drawers/downloadCuiAuditCsvDrawer/OPEN',
};

export const downloadCuiAuditCsvDrawer = {
  close: () => ({
    type: types.CLOSE,
  }),
  open: () => ({
    type: types.OPEN,
  }),
};
